import en from './en.json';
import zhCN from './zh_cn.json';
import zhHK from './zh_hk.json';

const resources = {
  en: {
    translation: en,
  },
  zh_CN: {
    translation: zhCN,
  },
  zh_HK: {
    translation: zhHK,
  },
};
export default resources;
